<button
  type="button"
  #toggleFilterButton
  (click)="handleFilterButtonDisplayClick()"
  [title]="
    !filterOpenOnSmallerViewports()
      ? ('pia.features.product-overview.productFamilyAside.openFilterButtonLabel'
        | translate)
      : ('pia.features.product-overview.productFamilyAside.closeFilterButtonLabel'
        | translate)
  "
  [ngClass]="{
    'adaptive-filter-toggle': true,
    hide: filterOpenOnSmallerViewports(),
  }"
>
  @if (filterOpenOnSmallerViewports()) {
    <claas-icon
      [iconId]="'648425'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    >
    </claas-icon>
  } @else {
    <claas-icon
      [iconId]="'648420'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    >
    </claas-icon>
  }
</button>
<aside [ngClass]="{ container: true, show: filterOpenOnSmallerViewports() }">
  <header class="aside-header">
    <h2 class="aside-headline font-2xl">
      {{ "features.product-overview.productFamilyAside.headline" | translate }}
    </h2>
    <button
      type="button"
      (click)="setShowAsideModal(true)"
      class="filter-settings-button icon-only-button"
      [title]="
        'pia.features.product-overview.productFamilyAside.openFilterSettingsButtonLabel'
          | translate
      "
    >
      <claas-icon
        [iconId]="'648638'"
        [namespace]="'pia'"
        [size]="24"
        [alt]="''"
        [removeDefaultColor]="true"
      ></claas-icon>
    </button>
    <div class="close-button-wrap">
      <button
        type="button"
        (click)="handleFilterButtonDisplayClick(false)"
        [title]="
          'pia.features.product-overview.productFamilyAside.closeFilterButtonLabel'
            | translate
        "
        class="close-button icon-only-button"
      >
        <claas-icon
          [iconId]="'006172'"
          [namespace]="'pia'"
          [size]="24"
          [alt]="''"
          [removeDefaultColor]="true"
        ></claas-icon>
      </button>
    </div>
  </header>
  <claas-aside-modal-dialog [(show)]="showAsideModal">
    <claas-product-family-filters
      class="modal-content"
      (closeFilters)="setShowAsideModal(false)"
    ></claas-product-family-filters>
  </claas-aside-modal-dialog>
  <ul class="anchor-list">
    @for (
      productFamily of this.productFamiliesFiltered();
      track productFamily.ID
    ) {
      <li class="anchor-list-item">
        <a [routerLink]="[]" [fragment]="productFamily.ID" class="anchor-link">
          <span>
            <claas-icon
              class="anchor-link-icon"
              [iconId]="
                productFamily.ID && productFamilyIconMap[productFamily.ID]
                  ? productFamilyIconMap[productFamily.ID]
                  : '783162'
              "
              [namespace]="'pia'"
              [attr.aria-hidden]="true"
              [size]="24"
              [alt]="''"
              [removeDefaultColor]="true"
            >
            </claas-icon>
          </span>
          <span class="font-m">{{ productFamily.Name }}</span>
        </a>
      </li>
    }
  </ul>
  <footer class="toggle-favourites-container">
    <claas-toggle
      id="toggle-button"
      [disabled]="false"
      [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
      [checked]="isChecked()"
      [required]="false"
      [disableRipple]="true"
      [inputTop]="false"
      [truncatedText]="true"
      (changed)="handleToggleFavouritesChange($event)"
    ></claas-toggle>
  </footer>
</aside>
